import { setLoginCookies, setWarehouseCookies } from './login';

import { dispatchMetric } from '../../metrics';
import { dispatchLoginSaikaEvent } from '../../stuart/saika-events';
import { getLoginSuccessfulEventPayload } from '../../metrics/metrics.selector';

async function persisteCookies(tokenResult = {}, customerResult = {}, finance, customerType, userSegments, warehouse) {
  const { id, token, b2wUid } = tokenResult;
  const { nickname, isPrime, region } = customerResult;
  setLoginCookies({ id, token, nickname, isPrime, region, finance, b2wUid, customerType, userSegments });
  setWarehouseCookies(warehouse);
}

export function dispatchEvents(tokenResult = {}, customerResult = {}, type) {
  try {
    const { status } = tokenResult;
    const { email } = customerResult;
    dispatchMetric('login:success', {
      email,
      status,
      type,
      payload: getLoginSuccessfulEventPayload(type)
    });
    dispatchLoginSaikaEvent({ email, status, type });
  } catch (error) {
    console.error(`Error in dispatchEvents`, error);
  }
}

export function persisteCustomerAndDispatchEvents({ token, customer, type, finance, userSegments, customerType, warehouse }) {
  dispatchEvents(token, customer, type);
  persisteCookies(token, customer, finance, customerType, userSegments, warehouse);
}
